export const QUERY_KEYS = {
  USER_LIST: ["user-list"],
  DASHBOARD: ["dashboard"],
  USER_DETAILS: ["user-details"],
  CATEGORIES: ["categories"],
  REPORTS:["reports"],
  POSTS:["posts"],
  STORIES:["stories"],
  BLOGS:["blogs"],
  POST_DETAILS:["post-details"],
  STORY_DETAILS:["story-details"],
  BLOG_DETAILS:["blog-details"],
  BLOG_CATEGORY:["blog-category"],
  STORY_CATEGORY:["story-category"],
  FEEDBACK:["feedback"]
};
